var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert';
import { BuildStatus } from '../../../enums/build-status';
import { StateTriggersEnum } from '../../../enums/workload/state-triggers';
import { WlmUrls } from '../../../enums/workload/wlm-urls';
import { StorageKeys } from '../../../enums/storage-keys';
import { WorkflowService } from '../../../services/workload/workflow.service';
import { StateTransitionUtil } from '../../../Utils/state-transition.util';
import { FormService } from '../../../services/workload/form.service';
import { TicketInformationService } from '../../../services/workload/ticket-information.service';
import { SessionStorageReader } from '../../../storage/session-storage.reader';
import { SessionStorageUpdater } from '../../../storage/session-storage.updater';
var WorkflowComponent = /** @class */ (function () {
    function WorkflowComponent(route, workflowService, formService, router, toastr, ticketService, sessionStorageReader, sessionStorageUpdater) {
        var _this = this;
        this.route = route;
        this.workflowService = workflowService;
        this.formService = formService;
        this.router = router;
        this.toastr = toastr;
        this.ticketService = ticketService;
        this.sessionStorageReader = sessionStorageReader;
        this.sessionStorageUpdater = sessionStorageUpdater;
        this.requestId = 0;
        this.status = BuildStatus.ReadyToBuild;
        this.isSidebarVisible = true;
        this.paramsSubscription = new Subscription();
        this.updateFormDataSubscription = new Subscription();
        this.isValidStateChangeSubscription = new Subscription();
        this.syncUpdate = new Subscription();
        this.getRequestCurrentState = new Subscription();
        this.viewModel = {
            requestId: 0,
            sidebar: {
                historySection: {
                    headerText: 'Activity'
                },
                requestInformationSection: {
                    headerText: 'Information'
                },
                togglerButton: {
                    altText: 'Collapse'
                }
            },
            buildStatusValues: {
                new: BuildStatus.ReadyToBuild,
                research: BuildStatus.Research,
                build: BuildStatus.Input,
                compare: BuildStatus.Comparison,
                approve: BuildStatus.Approval,
                amend: BuildStatus.Amend,
                live: BuildStatus.Live,
                complete: BuildStatus.Complete
            },
            buttonPanel: {
                previousButton: {
                    state: BuildStatus.ReadyToBuild,
                    visible: false,
                    altText: 'return to previous form state'
                },
                nextButton: {
                    state: BuildStatus.Research,
                    visible: false,
                    altText: 'Proceed to next form state'
                }
            }
        };
        this.paramsSubscription = this.route.params.subscribe(function (params) {
            _this.viewModel.requestId = params['requestId'];
        });
        this.updateButtonPanelText();
    }
    WorkflowComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.getRequestCurrentState = this.workflowService.getRequestState(this.viewModel.requestId).subscribe(function (currentState) {
            if (currentState)
                _this.status = currentState;
            _this.updateButtonPanelText();
        });
        this.isSidebarVisible = this.sidebarVisible();
    };
    WorkflowComponent.prototype.ngOnDestroy = function () {
        this.paramsSubscription.unsubscribe();
        this.updateFormDataSubscription.unsubscribe();
        this.isValidStateChangeSubscription.unsubscribe();
        this.syncUpdate.unsubscribe();
        this.getRequestCurrentState.unsubscribe();
    };
    WorkflowComponent.prototype.changeBuildStatus = function (getNextState) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var formSync, nextState;
            return __generator(this, function (_a) {
                formSync = {
                    formData: {
                        data: '',
                        requestId: this.viewModel.requestId,
                        state: this.status,
                        id: 0
                    },
                    isFormValid: true,
                    triggers: StateTransitionUtil.getStateTrigger(this.status, getNextState)
                };
                nextState = StateTransitionUtil.determineNextState(this.status, getNextState);
                if (nextState === BuildStatus.Complete) {
                    swal({
                        title: 'Request completed?',
                        icon: 'warning',
                        buttons: ['No', 'Yes']
                    }).then(function (willComplete) {
                        if (willComplete) {
                            _this.moveToNextState(formSync);
                            _this.toastr.success('', 'Request Complete!', {
                                timeOut: 3000,
                                positionClass: 'toast-bottom-right'
                            });
                            _this.router.navigate([WlmUrls.Dashboard]);
                        }
                    });
                }
                else {
                    this.moveToNextState(formSync);
                }
                return [2 /*return*/];
            });
        });
    };
    WorkflowComponent.prototype.updateButtonPanelText = function () {
        this.viewModel.buttonPanel.previousButton.state = StateTransitionUtil.determineNextState(this.status, false);
        var isVisible = false;
        switch (this.status) {
            case BuildStatus.ReadyToBuild:
            case BuildStatus.Research:
                break;
            default:
                isVisible = true;
        }
        this.viewModel.buttonPanel.previousButton.visible = isVisible;
        this.viewModel.buttonPanel.nextButton.state = StateTransitionUtil.determineNextState(this.status, true);
        this.viewModel.buttonPanel.nextButton.visible = (this.status !== BuildStatus.Complete);
    };
    WorkflowComponent.prototype.saveFormData = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var staffId;
            return __generator(this, function (_a) {
                if (data.triggers === StateTriggersEnum.ReAssignStaff) {
                    staffId = JSON.parse(data.formData.data).assignedUser;
                    this.ticketService.staffAssigned(staffId);
                }
                this.formService.updateFormData(data).then();
                return [2 /*return*/];
            });
        });
    };
    WorkflowComponent.prototype.toggleSidebar = function () {
        var isToggled = this.sidebarVisible();
        isToggled = !isToggled;
        this.sessionStorageUpdater.setItem(StorageKeys.WorkloadInformationSidebar, isToggled.toString());
        this.isSidebarVisible = isToggled;
    };
    WorkflowComponent.prototype.sidebarVisible = function () {
        return this.sessionStorageReader.getItem(StorageKeys.WorkloadInformationSidebar) === 'true';
    };
    WorkflowComponent.prototype.formUnlocked = function (status) {
        this.status = status;
        this.ticketService.statusUpdated(status);
        this.updateButtonPanelText();
    };
    WorkflowComponent.prototype.moveToNextState = function (formSync) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.formService.updateFormData(formSync).then(function (newState) {
                            _this.status = newState;
                            _this.ticketService.statusUpdated(_this.status);
                        })];
                    case 1:
                        _a.sent();
                        this.updateButtonPanelText();
                        return [2 /*return*/];
                }
            });
        });
    };
    WorkflowComponent = __decorate([
        Component({
            selector: 'workflow-dashboard',
            template: require('./workflow.component.html'),
            styles: [require('./workflow.component.scss')]
        }),
        __metadata("design:paramtypes", [ActivatedRoute,
            WorkflowService,
            FormService,
            Router,
            ToastrService,
            TicketInformationService,
            SessionStorageReader,
            SessionStorageUpdater])
    ], WorkflowComponent);
    return WorkflowComponent;
}());
export { WorkflowComponent };
//# sourceMappingURL=data:application/json;base64,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